import { DateInputProps } from "@mantine/dates";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import cheerio from "cheerio";

export const get = (
  obj: Record<string, any>,
  keys: string | Array<string>,
  defaultVal?: any
) => {
  keys = Array.isArray(keys) ? keys : keys.split(".");
  obj = obj[keys[0]];
  if (obj && keys.length > 1) {
    return get(obj, keys.slice(1));
  }
  return obj === undefined ? defaultVal : obj;
};

export const sanitizeObject = (obj: Record<string, any>) => {
  const newObj: Record<string, any> = {};
  Object.keys(obj)?.map((k) => {
    if (!!obj[k] || obj[k] === 0) {
      newObj[k] = obj[k];
    }
  });

  return newObj;
};

export function findKeyByValue(obj, value) {
  for (const key in obj) {
    if (obj[key] === value) {
      return key;
    }
  }
  return null;
}
export function maskPhoneNumber(number?: number | string): string | null {
  if (number === undefined || number === null) {
    console.error("The input number cannot be undefined or null.");
    return null;
  }

  // Convert the number to a string if it's not already
  let str = number.toString();

  // Check if the length is 10 digits
  if (str.length !== 10) {
    console.error("The input number must be 10 digits long.");
    return null;
  }

  // Take the first 2 and last 4 digits and mask the middle with 'x'
  return str.substring(0, 2) + "xxxx" + str.substring(6);
}

/**
 * Custom hook for fetching and processing country data based on the user's IP address.
 *
 * Usage: const { isIndian } = useFetchCountryData();
 */
// export const useFetchCountryData = () => {
//   const [isIndian, setIsIndian] = useState(null);
//   useEffect(() => {
//     async function fetchData() {
//       try {
//         // Fetch the IP address
//         const ipRes = await fetch("https://api.ipify.org/?format=json");
//         if (!ipRes.ok) {
//           throw new Error("IP address request failed");
//         }
//         const ipData = await ipRes.json();

//         // Fetch country data using the retrieved IP address
//         const countryRes = await fetch(`/api/ipData`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/x-www-form-urlencoded", // Set the content type as needed
//           },
//           body: `ipAddress=${ipData.ip}`,
//         });
//         if (!countryRes.ok) {
//           throw new Error("Country data request failed");
//         }
//         const countryData = await countryRes.json();

//         // Process the country data
//         const isIndian = countryData.isIndian;
//         setIsIndian(isIndian);
//         // You can also set other state variables here if needed.
//       } catch (error) {
//         console.error("Error:", error);
//       }
//     }

//     fetchData();
//   }, []);

//   return { isIndian };
// };

export function areArraysEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }

  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }

  return true;
}

export const dateParser: DateInputProps["dateParser"] = (input) => {
  if (input === "WW2") {
    return new Date(1939, 8, 1);
  }
  return new Date(input);
};

export function findNearestBiggestNumber(arr, target) {
  let nearestBigger = Infinity;
  target = Number(target);
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] >= target && arr[i] < nearestBigger) {
      nearestBigger = arr[i];
    }
  }

  return nearestBigger === Infinity ? null : nearestBigger;
}

export const showError = (error: any) => {
  const message = error.response ? error.response.data.message : error.message;
  toast.error(message || "Something went wrong");
};

export const portEndDates = (startDateFromNow = false) => {
  const startDate = startDateFromNow ? dayjs() : dayjs().subtract(30, "day");
  const endDate = dayjs().add(59, "day");

  const formattedStartDate = startDate.format("DD MMM YYYY");
  const formattedEndDate = endDate.format("DD MMM YYYY");

  return { formattedStartDate, formattedEndDate };
};

export function capitalize(word) {
  if (typeof word !== "string") {
    return word; // If not a string, return the original value
  }

  return word
    .split(" ")
    .map((item) => item.charAt(0).toUpperCase() + item.slice(1))
    .join(" ");
}

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function getCookie(name: string): string {
  const value = `; ${document?.cookie}`;
  const parts = value?.split(`; ${name}=`);
  if (parts?.length === 2) {
    return parts?.pop()?.split(";")?.shift() || "";
  } else {
    return "";
  }
}

export function extractFirstParagraph(html) {
  try {
    const $ = cheerio.load(html);
    let firstParagraphText = "";
    let index = 0;
    while (true) {
      const paragraphText = $("p").eq(index).text();

      // Break the loop if there are no more <p> elements
      if (!paragraphText) {
        break;
      }

      // Check if the paragraph text is at least 100 characters
      if (paragraphText.length >= 100) {
        firstParagraphText = paragraphText;
        break;
      }

      index++;
    }

    // if (firstParagraphText === "") {
    //   while (true) {
    //     const paragraphText = $("p").eq(index).text();
    //     firstParagraphText = firstParagraphText + paragraphText;

    //     // Check if the paragraph text is at least 100 characters
    //     if (firstParagraphText.length >= 100) {
    //       break;
    //     }

    //     index++;
    //   }
    //   return firstParagraphText;
    // }
    return firstParagraphText;
  } catch (error) {
    return "There was an error extracting the text...";
  }
}

export const fetchPathNameForLeadSource = (): { domain: any; path: any } => {
  if (typeof window === "undefined") return { domain: "", path: "" };

  const url = window.location.href || "";
  const urlObj = new URL(url);
  const protocol = urlObj.protocol;
  const hostname = urlObj.hostname;
  const port = urlObj.port;

  const domain: any = port
    ? `${protocol}//${hostname}:${port}`
    : `${protocol}//${hostname}`;

  // Get pathname
  const path = urlObj.pathname;

  return { domain, path };
};

export const blockOnLeadSource: string[] = ["/become-an-agent-portal.html", ""];

export const leadSourceIdentification = (): string => {
  let { domain, path = "" } = fetchPathNameForLeadSource();
  
  if (!path || path === "/") {
    const cleanDomain = domain
      ?.replace(/^(https?:\/\/)?(www\.)?/, '')
      ?.split('/')[0]
      ?.split('?')[0] || "";
    
    if (!cleanDomain) return "";
    
    const existingPath: string | null = sessionStorage.getItem("leadSourcePath");
    const currentQuoteId: string | null = sessionStorage.getItem("quoteId");
    const storedQuoteId: string | null = sessionStorage.getItem("storedQuoteId");
    
    if (!existingPath) {
      sessionStorage.setItem("leadSourcePath", cleanDomain);
      if (currentQuoteId) {
        sessionStorage.setItem("storedQuoteId", currentQuoteId);
      }
      return cleanDomain;
    }
    
    if (existingPath !== cleanDomain && !storedQuoteId) {
      sessionStorage.setItem("leadSourcePath", cleanDomain);
      if (currentQuoteId) {
        sessionStorage.setItem("storedQuoteId", currentQuoteId);
      }
      return cleanDomain;
    }
    
    if (currentQuoteId && currentQuoteId !== storedQuoteId) {
      sessionStorage.setItem("storedQuoteId", currentQuoteId);
    }
    
    return existingPath;
  }
  
  const segments: string[] = path
    .split("/")
    .filter((segment) => segment !== "");
 
  if (segments?.length === 0) return "";
 
  let result: string;
  if (segments?.length === 1) {
    result = segments[0];
    if (result.endsWith(".html")) {
      result = result.slice(0, -5);
    }
  } else {
    result = segments[segments.length - 2];
  }
 
  const existingPath: string | null = sessionStorage.getItem("leadSourcePath");
  const currentQuoteId: string | null = sessionStorage.getItem("quoteId");
  const storedQuoteId: string | null = sessionStorage.getItem("storedQuoteId");
 
  if (!existingPath) {
    sessionStorage.setItem("leadSourcePath", result);
    if (currentQuoteId) {
      sessionStorage.setItem("storedQuoteId", currentQuoteId);
    }
    return result;
  }
 
  if (existingPath !== result && !storedQuoteId) {
    sessionStorage.setItem("leadSourcePath", result);
    if (currentQuoteId) {
      sessionStorage.setItem("storedQuoteId", currentQuoteId);
    }
    return result;
  }
 
  if (currentQuoteId && currentQuoteId !== storedQuoteId) {
    sessionStorage.setItem("storedQuoteId", currentQuoteId);
  }
 
  return existingPath;
};

export type DeviceType = 'mobile' | 'desktop' | 'tablet';

/**
 * Returns current device type and caches it in sessionStorage.
 */
export const getDeviceType = (): DeviceType => {
  if (typeof window === 'undefined') return 'desktop'; // SSR safety

  // Check if already stored
  const storedDevice = sessionStorage.getItem("deviceType") as DeviceType | null;
  if (storedDevice) return storedDevice;

  const userAgent = navigator.userAgent.toLowerCase();
  const width = window.innerWidth;

  const isTablet =
    /ipad|tablet|kindle|silk|gt-p|sch-i800|playbook|xoom|sm-t|tab|nexus 7|nexus 10/i.test(userAgent) ||
    (width >= 768 && width <= 1024);

  const isMobile =
    /android|webos|iphone|ipod|blackberry|iemobile|opera mini|mobile/i.test(userAgent) ||
    (width <= 767 && !isTablet);

  let device: DeviceType = 'desktop';
  if (isTablet) device = 'tablet';
  else if (isMobile) device = 'mobile';

  sessionStorage.setItem("deviceType", device);
  return device;
};

/**
 * Returns current slug (last path segment) and caches it in sessionStorage.
 * Updates if URL changes.
 */
export const getSlug = (): string => {
  if (typeof window === "undefined") return "";

  const currentPath = new URL(window.location.href).pathname;
  const segments = currentPath.split("/").filter(Boolean);
  const slug = segments.length ? segments[segments.length - 1] : "";

  const storedSlug = sessionStorage.getItem("slug") || "";
  const lastUrl = sessionStorage.getItem("lastUrl") || "";

  // Store if first time or slug/URL changed
  if (!storedSlug || lastUrl !== window.location.href) {
    sessionStorage.setItem("slug", slug);
    sessionStorage.setItem("lastUrl", window.location.href);
    return slug;
  }

  return storedSlug;
};

export const calculationFormatDateInput = (
  input: string,
  cursorPos: number
): string => {
  // Remove all non-digit characters
  const digits = input.replace(/\D/g, "");

  // Limit to 8 digits (ddmmyyyy)
  const limitedDigits = digits.slice(0, 8);

  let formatted = "";

  // Add digits with slashes at appropriate positions
  for (let i = 0; i < limitedDigits.length; i++) {
    // Add slash after day (position 2) and month (position 4)
    if (i === 2 || i === 4) {
      formatted += "/";
    }
    formatted += limitedDigits[i];
  }

  return formatted;
};

export const calculationParseAndValidateDate = (
  formattedDate: string
): Date | null => {
  if (!formattedDate.includes("/")) return null;

  // Parse the date in local timezone to avoid timezone issues
  const date = dayjs(formattedDate, "DD/MM/YYYY", true).hour(12);
  const currentYear = dayjs().year();
  const today = dayjs().hour(12).startOf("day");

  // Validate date existence and year range
  if (!date.isValid() || date.year() < 1900 || date.year() > currentYear) {
    return null;
  }

  // Check if date is in the future
  if (date.isAfter(today)) {
    return null;
  }

  // Return the date in local timezone
  return date.toDate();
};

export const calculationParseDateInputNew = (input: string): Date => {
  const parsedDate = calculationParseAndValidateDate(input);
  return parsedDate || new Date(NaN); // Invalid Date
};
